var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFishing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 37.875,
    y1: 65.5,
    x2: 10,
    y2: 65.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 85.912,
    y1: 65.5,
    x2: 37.875,
    y2: 65.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 85.912,
    y1: 65.5,
    x2: 96,
    y2: 65.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 10,
    y1: 65.5,
    x2: 5,
    y2: 65.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 96,
    y1: 73.5,
    x2: 5,
    y2: 73.5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 96,
    y1: 81,
    x2: 5,
    y2: 81
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 55.5,
    y1: 51,
    x2: 39.906,
    y2: 51
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 85.912,65.5 97,51 55.5,51  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 39.906,
    y1: 51,
    x2: 39.5,
    y2: 51
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M37.875,65.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 37.875,65.5 27,51 39.5,51  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M85.912,65.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 10,65.5 10,22 39.5,50.606  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M39.906,51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M10,65.5"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 39.906,
    y1: 51,
    x2: 39.5,
    y2: 50.606
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M47.5,33c0,0-8,2-8,7c0,2.696,0,7.654,0,10.606"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M39.5,50.606c0,0.137,0,0.266,0,0.394"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M39.5,51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M55.5,51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M55.5,51c0-2.884,0-8.179,0-11c0-5-8-7-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M47.5,33c3.038,0,5.5-3.462,5.5-6.5S50.538,21,47.5,21S42,23.462,42,26.5S44.462,33,47.5,33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishing);
export default __webpack_public_path__ + "static/media/fishing.038865fc0497ba57d0a96a0e1d07d95a.svg";
export { ForwardRef as ReactComponent };